import {
  Box,
  Button,
  Container,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import Cover from "./Cover";
import axios from "axios";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CheckCircleIcon from "@material-ui/icons/CheckCircle"; // Import the icon

import { makeStyles } from "@material-ui/core/styles";
import { appUrl } from "../../../../../../utils/config";
import { fetchTeamAssociates } from "../../../../containers/actions/common/teamMemberAction";
import { useDispatch } from "react-redux";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../../containers/actions/types";
const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "2em",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "1em",
  },
  warningBox: {
    padding: "10px",
    border: "2px solid red",
    borderRadius: "4px",
  },
  warningText: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "red",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  dialog: {
    // Target the dialog root
    "& .MuiPaper-root": {
      borderRadius: "16px", // Rounded corners
    },
  },
  dialogTitle: {
    padding: "24px 24px 0", // Adjust padding
    textAlign: "center", // Center the title
  },
  titleText: {
    // Style the title text
    fontWeight: 600,
    fontSize: "1.5rem", // Adjust as needed
    color: "#212121", // Darker text color
  },
  checkIcon: {
    color: "#008002", // Green color
    fontSize: "3rem", // Large icon size
    marginBottom: "1rem", // Space below icon
  },
  dialogContent: {
    padding: "20px 24px 24px", // Adjust padding
    textAlign: "center", // Center content
  },
  contentText: {
    color: "#424242", // Slightly lighter text
  },
  dialogActions: {
    padding: "16px", // Adjust padding
    justifyContent: "center", // Center the button
  },
  okButton: {
    backgroundColor: "#ec6535", // Orange background
    color: "white", // White text
    textTransform: "none", // Remove uppercase transform
    padding: "8px 30px", // Adjust padding for pill shape
    minWidth: "100px", // optional, set min width for button
    borderRadius: "20px", // Slightly rounded corners
    "&:hover": {
      backgroundColor: "#ec6535", // Darker orange on hover
    },
  },
}));
export default function CdmoWarning({
  setCdmoDrawer,
  associatedIds,
  user,
  setViewDetailsDrawer,
  handleRefresh,
  selectedRole,
}) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const handleOk = () => {
    setViewDetailsDrawer(false);
    handleRefresh();
    setError(null);
    if (selectedRole) {
      dispatch({
        type: FETCH_TEAM_ASSOCIATES_LOADING,
        payload: true,
      });
      dispatch(
        fetchTeamAssociates({
          departmentID: selectedRole.departmentID,
          collaborator_role_id: selectedRole.collaborator_role_id,
          searchString: "all",
          status: "Active",
        })
      );
    }
  };
  // const handleConfirm = () => {
  //   const requestObject = [
  //     {
  //       saas_user_id: user.saas_user_id,
  //       associated_cdmo_org_ids: associatedIds,
  //     },
  //   ];
  //   // console.log("🚀 ~ handleConfirm ~ requestObject:", requestObject);
  //   // const url = "/updateUserDetails";
  //   const url = `${appUrl}/user/updateTeamMemberDetails`;
  //   setLoading(true);
  //   setError(null);
  //   axios
  //     .post(url, requestObject)
  //     .then((res) => {
  //       if (res.data.status) {
  //         setShowDialog(true);
  //       } else {
  //         setError("Update failed");
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("API Error", err.message);
  //       setError(err.message || "An error occurred");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };
 
   const handleConfirm = () => {
    const requestObject = 
      {
        saasUserID: user?.saas_user_id,
        associatedBrandList: [],
          associatedProductTypesList:[],
          associatedCMOList:associatedIds,
            collaboratorRoleID:user?.collaborator_role_id || null,
            isActive: user.account_status === "Active" ? true : false,
      }
    ;
    // console.log("🚀 ~ handleConfirm ~ requestObject:", requestObject);
    // const url = "/updateUserDetails";
    const url =  `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUserAssociations`;
    setLoading(true);
    setError(null);
    axios
      .post(url, requestObject)
      .then((res) => {
        if (res.data.status) {
          setShowDialog(true);
        } else {
          setError("Update failed");
        }
      })
      .catch((err) => {
        setError(err.message || "An error occurred");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",
        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
        handleRefresh={handleRefresh}
      />
      <Container
        style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography className={classes.heading}>Warning</Typography>
        <Box className={classes.warningBox}>
          <Typography className={classes.warningText}>
            CMO change: You are changing the CMOs associated with the user.
            The team member may lose permissions to access few areas of the
            application.
          </Typography>
        </Box>
        {error && displayError}
        {loading && displayLoading}

        <Box className={classes.buttonContainer}>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={() => setCdmoDrawer(false)}
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            className={classes.btnPrimary}
            variant="contained"
            size="small"
            //   color="primary"
            style={{
              textTransform: "none",
              backgroundColor: "#286acf",
              color: "#fff",
            }}
            onClick={handleConfirm}
            // onClick={() => setCdmoDrawer(false)}
          >
            Confirm changes
          </Button>
        </Box>
      </Container>
      <Dialog
        open={showDialog}
        keepMounted
        onClose={() => setShowDialog(false)}
        className={classes.dialog}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle className={classes.dialogTitle}>
          <CheckCircleIcon className={classes.checkIcon} />
          <Typography variant="h6" className={classes.titleText}>
            {" "}
            {/* Style the title */}
            Success
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText className={classes.contentText}>
            Associated CMOs updated successfully
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={handleOk}
            className={classes.okButton}
            variant="contained"
            endIcon={<ChevronRightIcon>send</ChevronRightIcon>}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
